import Link from "next/link";
import type { AuthorProfile } from "~/lib/authors";

type Props = {
  author: AuthorProfile;
};

export const AuthorBox: React.FC<Props> = ({ author }) => {
  const authorHref = `/autorzy/${author.slug}/`;
  const paragraphs = author.bio
    .split(/\n\s*\n/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);

  return (
    <aside className="mt-10 rounded-2xl border border-sky-100 bg-gradient-to-br from-sky-50 via-white to-sky-100/70 p-6 shadow-sm sm:p-8">
      <div className="min-w-0">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">
          Autor artykułu
        </p>
        <div className="mt-2 flex flex-col gap-1 sm:flex-row sm:items-baseline sm:gap-3">
          <h2 className="text-2xl font-semibold text-gray-900">
            <Link href={authorHref} className="hover:text-sky-800">
              {author.name}
            </Link>
          </h2>
          <p className="text-sm font-medium text-sky-800">{author.role}</p>
        </div>
        <p className="mt-4 text-sm leading-relaxed text-gray-700">
          {author.shortBio}
        </p>

        {paragraphs.map((paragraph) => (
          <p
            key={paragraph}
            className="mt-3 text-sm leading-relaxed text-gray-600"
          >
            {paragraph}
          </p>
        ))}

        {author.specialties.length > 0 && (
          <ul className="mt-5 flex flex-wrap gap-2">
            {author.specialties.map((specialty) => (
              <li
                key={specialty}
                className="rounded-full bg-white px-3 py-1 text-xs font-medium text-sky-800 ring-1 ring-sky-100"
              >
                {specialty}
              </li>
            ))}
          </ul>
        )}

        <Link
          href={authorHref}
          className="mt-5 inline-flex text-sm font-medium text-sky-800 underline underline-offset-4 hover:text-sky-950"
        >
          Zobacz profil autora
        </Link>
      </div>
    </aside>
  );
};
